import React from 'react'
import { ArrowRight, ArrowLeft } from 'kunstmuseum-icons'

class InlineCredits extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            creditsOpened: false
        }

        this.toggleCredits = this.toggleCredits.bind(this)
    }

    toggleCredits() {
        this.setState({
            creditsOpened: !this.state.creditsOpened
        })
    }

    render() {
        return (
            <>
                {this.props.credit && 
                    <button className="credits" onClick={this.toggleCredits}>
                        {!this.state.creditsOpened ?
                            <>
                                <ArrowRight />
                                Credits
                            </>
                            :
                            <>
                                <ArrowLeft />
                                {this.props.credit}
                            </>
                        }
                    </button>
                }
            </>
        )
    }
}

export default InlineCredits